import { DesignData, MediaImage, MediaText } from 'editor/src/store/design/types';

import collectBoundTextColumns from './collectBoundTextColumns';
import getQrFieldVariableColumn from './getQrFieldVariableColumn';
import { VariableDataBindings } from './types';

/**
 * Every place the design reads a code-set column: texts printing one, and QR
 * fields encoding one, directly or through a bound text. Walks all spreads,
 * because a card's back is as bound as its front and production materialises
 * the whole design per unit.
 */
function collectVariableDataBindings(designData: DesignData | undefined): VariableDataBindings {
  const bindings: VariableDataBindings = { texts: [], qrFields: [], columns: [] };
  const boundTextColumns = collectBoundTextColumns(designData);
  const seen = new Set<string>();
  const note = (column: string) => {
    if (!seen.has(column)) {
      seen.add(column);
      bindings.columns.push(column);
    }
  };

  designData?.spreads.forEach((spread) =>
    spread.pages.forEach((page) =>
      page.groups.media?.forEach((element) => {
        if (element.type === 'text') {
          const { variableColumn, maxCharCount } = (element as MediaText).extra;
          if (variableColumn) {
            bindings.texts.push({ uuid: element.uuid, column: variableColumn, maxCharCount });
            note(variableColumn);
          }
          return;
        }
        if (element.type === 'image') {
          (element as MediaImage).qrCode?.fields.forEach((field) => {
            const column = getQrFieldVariableColumn(field.source, boundTextColumns);
            if (column !== undefined) {
              bindings.qrFields.push({ uuid: element.uuid, fieldKey: field.key, column });
              note(column);
            }
          });
        }
      }),
    ),
  );

  return bindings;
}

export default collectVariableDataBindings;
